<template>
  <div class="property-owner-page">
    <div class="property-white-card">
      <div class="property-page-header">
        <div class="property-page-title">业主信息</div>
        <div class="property-header-divider"></div>
        <div class="property-header-row">
          <div class="property-btn-group">
            <el-button size="small" class="property-btn-add" @click="openAddOwnerModal">
              <i class="el-icon-plus"></i>添加
            </el-button>
            <el-button size="small" class="property-btn-refresh" title="刷新" @click="listOwnerData">
              <i class="el-icon-refresh-right"></i>
            </el-button>
          </div>
          <div class="property-search-group">
            <el-input v-model="keyword" placeholder="请输入" size="small" class="property-search-input" clearable @keyup.enter.native="queryOwnerMethod" />
            <el-button size="small" class="property-btn-search" @click="queryOwnerMethod">
              <i class="el-icon-search"></i>搜索
            </el-button>
          </div>
        </div>
      </div>

      <div class="property-table-section">
        <el-table v-loading="loading" :data="owners" style="width: 100%" :fit="true" :header-cell-style="headerCellStyle" :cell-style="cellStyle">
          <el-table-column label="头像" min-width="88" align="center">
            <template slot-scope="scope">
              <el-image class="owner-avatar" :src="scope.row.faceUrl || '/img/noPhoto.jpg'" :preview-src-list="[scope.row.faceUrl || '/img/noPhoto.jpg']" fit="cover" />
            </template>
          </el-table-column>
          <el-table-column prop="name" label="姓名" min-width="132" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="owner-name-link" @click="openOwnerDetail(scope.row)">{{ scope.row.name || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="communityName" label="小区" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.communityName || getCommunityName(scope.row.communityId) || '-' }}</template>
          </el-table-column>
          <el-table-column prop="personTypeName" label="人员类型" min-width="104" show-overflow-tooltip />
          <el-table-column prop="personRoleName" label="人员角色" min-width="104" show-overflow-tooltip />
          <el-table-column prop="sex" label="性别" min-width="76">
            <template slot-scope="scope">{{ String(scope.row.sex) === '0' ? '男' : '女' }}</template>
          </el-table-column>
          <el-table-column prop="idCard" label="证件号" min-width="190" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.idCard || '-' }}</template>
          </el-table-column>
          <el-table-column prop="link" label="联系电话" min-width="132" show-overflow-tooltip />
          <el-table-column label="房屋数" min-width="82">
            <template slot-scope="scope">
              <a class="action-link" @click="viewOwnerRooms(scope.row)">{{ scope.row.roomCount || 0 }}</a>
            </template>
          </el-table-column>
          <el-table-column label="业主成员" min-width="96">
            <template slot-scope="scope">
              <a v-if="scope.row.ownerTypeCd === '1001'" class="action-link" @click="viewOwnerMembers(scope.row)">{{ scope.row.memberCount || 0 }}</a>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="车辆数" min-width="82">
            <template slot-scope="scope">
              <a class="action-link" @click="viewOwnerCars(scope.row)">{{ scope.row.carCount || 0 }}</a>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" min-width="190">
            <template slot-scope="scope">
              <span class="action-links">
                <a class="action-link" @click="openOwnerDetail(scope.row)">详情</a>
                <span class="link-separator"></span>
                <a class="action-link" @click="openEditOwnerModal(scope.row)">编辑</a>
                <span class="link-separator"></span>
                <a class="action-link danger" @click="openDeleteOwnerModal(scope.row)">删除</a>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="property-pagination">
        <span class="pagination-total">共{{ total }}条</span>
        <el-pagination :current-page="currentPage" :page-size="pageSize" layout="prev, pager, next" :total="total" @current-change="handlePageChange" />
        <el-select v-model="pageSize" size="small" class="pagination-size-select" @change="handleSizeChange">
          <el-option label="10条/页" :value="10" />
          <el-option label="20条/页" :value="20" />
          <el-option label="50条/页" :value="50" />
        </el-select>
      </div>
    </div>

    <add-owner ref="addOwner" @success="handleOwnerSuccess" />
    <edit-owner ref="editOwner" @success="handleOwnerSuccess" />
    <delete-owner ref="deleteOwner" @success="handleOwnerSuccess" />
    <owner-rooms ref="ownerRooms" />
    <owner-members ref="ownerMembers" />
    <owner-cars ref="ownerCars" />
  </div>
</template>

<script>
import { queryOwners } from '@/api/owner/ownerApi'
import AddOwner from '@/components/owner/addOwner'
import EditOwner from '@/components/owner/editOwner'
import DeleteOwner from '@/components/owner/deleteOwner'
import OwnerRooms from '@/components/owner/ownerRooms'
import OwnerMembers from '@/components/owner/ownerMembers'
import OwnerCars from '@/components/owner/ownerCars'
import { listMyEnteredCommunitys } from '@/api/community/communityManageApi'

export default {
  name: 'PropertyOwnerManageList',
  components: { AddOwner, EditOwner, DeleteOwner, OwnerRooms, OwnerMembers, OwnerCars },
  data() {
    return {
      loading: false,
      owners: [],
      keyword: '',
      conditions: {
        personRole: '',
        name: '',
        roomName: '',
        link: '',
        idCard: '',
        personType: ''
      },
      communityOptions: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  created() {
    this.loadCommunityOptions()
    this.listOwnerData()
  },
  methods: {
    async loadCommunityOptions() {
      try {
        const res = await listMyEnteredCommunitys({ page: 1, row: 1000 })
        this.communityOptions = res.communitys || res.data || []
      } catch (error) {
        this.communityOptions = []
      }
    },
    async listOwnerData() {
      this.loading = true
      try {
        const keyword = this.keyword.trim()
        const params = {
          ...this.conditions,
          name: keyword,
          page: this.currentPage,
          row: this.pageSize
        }
        const { data, total } = await queryOwners(params)
        this.owners = data || []
        this.total = Number(total || 0)
      } catch (error) {
        this.$message.error(error.message || '获取业主信息失败')
      } finally {
        this.loading = false
      }
    },
    queryOwnerMethod() {
      this.currentPage = 1
      this.listOwnerData()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.listOwnerData()
    },
    handlePageChange(page) {
      this.currentPage = page
      this.listOwnerData()
    },
    openAddOwnerModal() { this.$refs.addOwner.open() },
    openEditOwnerModal(owner) { this.$refs.editOwner.open(owner) },
    openDeleteOwnerModal(owner) { this.$refs.deleteOwner.open(owner) },
    handleOwnerSuccess() { this.listOwnerData() },
    viewOwnerRooms(owner) { this.$refs.ownerRooms.open(owner) },
    viewOwnerMembers(owner) { this.$refs.ownerMembers.open(owner.ownerId) },
    viewOwnerCars(owner) { this.$refs.ownerCars.open(owner.ownerId) },
    openOwnerDetail(owner) { this.$router.push(`/pages/property/ownerDetail?ownerId=${owner.ownerId}`) },
    getCommunityName(communityId) {
      const community = this.communityOptions.find(item => item.communityId === communityId)
      return community ? community.name : ''
    },
    headerCellStyle() { return { background: '#EBF2FA', color: '#364153', fontSize: '14px', fontWeight: '400', fontFamily: 'PingFang SC', height: '50px' } },
    cellStyle({ row }) {
      const rowIndex = this.owners.indexOf(row)
      return { background: rowIndex % 2 === 1 ? '#F8FBFF' : '#FFFFFF', color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC', height: '50px' }
    }
  }
}
</script>

<style lang="scss" scoped>
.property-owner-page { padding: 20px; background: #EBF2FA; min-height: calc(100vh - 100px); }
.property-white-card { background: #fff; border-radius: 12px; padding: 22px 24px; min-height: calc(100vh - 120px); }
.property-page-title { color: #1D2129; font: 600 16px/22px 'PingFang SC', sans-serif; }
.property-header-divider { height: 1px; background: #DCE6F5; margin: 18px -24px 22px; }
.property-header-row, .property-btn-group, .property-search-group, .action-links, .property-pagination { display: flex; align-items: center; }
.property-header-row { justify-content: space-between; gap: 12px; margin-bottom: 24px; }
.property-btn-group, .property-search-group { gap: 12px; }
.property-search-group { justify-content: flex-end; flex: 1; }
.property-btn-add, .property-btn-refresh, .property-btn-search { height: 38px; border-radius: 10px; padding: 0 16px; font: 500 14px/38px Inter, 'PingFang SC', sans-serif; }
.property-btn-add { background: #0E76FF; border-color: #0E76FF; color: #fff; }
.property-btn-refresh { width: 38px; padding: 0; background: #fff; border-color: #DCE6F5; color: #8C9BB4; }
.property-btn-search { background: #fff; border-color: #0E76FF; color: #0E76FF; }
.property-search-input { width: 180px; }
::v-deep .property-search-input .el-input__inner { height: 38px; border-radius: 10px; border-color: #DCE6F5; }
.property-table-section { border-radius: 10px; overflow: hidden; }
.owner-avatar { width: 42px; height: 42px; border-radius: 8px; background: #C4DDFF; }
.owner-name-link, .action-link { color: #0E76FF; cursor: pointer; }
.action-link.danger { color: #FB2C36; }
.link-separator { width: 1px; height: 14px; background: #DCE6F5; margin: 0 8px; }
.property-pagination { justify-content: flex-end; gap: 8px; margin-top: 20px; }
.pagination-total { color: #1D2129; font: 500 14px/22px 'PingFang SC', sans-serif; }
.pagination-size-select { width: 90px; }
::v-deep .pagination-size-select .el-input__inner { height: 32px; border: 0; border-radius: 8px; background: #F2F3F5; }
</style>
